module.exports = __webpack_public_path__ + "img/Natur2.41fa4537.svg";